import apiClient from "utils/apiClient";

const TASKS_BASE = "/olitask-service/api/v1/tasks";
const CARE_TASKS_BASE = "/olitask-service/api/v1/caretasks";
const TRAVO_TASKS_BASE = "/olitask-service/api/v1/travotasks";

const unwrap = (response) => response?.data;

export const createTaskRequest = (payload, taskType = "GENERAL") => {
  const normalizedType = String(taskType || payload?.taskType || "GENERAL").toUpperCase();
  const endpoint =
    normalizedType === "CARE" || normalizedType === "CARETASK"
      ? CARE_TASKS_BASE
      : normalizedType === "TRAVO" || normalizedType === "TRAVOTASK"
        ? TRAVO_TASKS_BASE
        : TASKS_BASE;

  return apiClient.post(endpoint, payload).then(unwrap);
};

export const listTaskRequests = (params = {}) =>
  apiClient.get(TASKS_BASE, { params }).then(unwrap);

export const listFilteredTaskRequests = (params = {}) =>
  apiClient.get(`${TASKS_BASE}/filter`, { params }).then(unwrap);

const olitaskTaskService = {
  create: createTaskRequest,
  list: listTaskRequests,
  filter: listFilteredTaskRequests,
};

export default olitaskTaskService;
